import { Message } from '@raysee/schema';
import { Props } from './Bubble';
import { TextBubble } from './TextBubble';
import dayjs from 'dayjs';
import Image from 'next/image';
import { FC } from 'react';
import { Element } from 'react-scroll';

interface BubbleProps extends Props {
  onClick?: (url: string, message: Message) => void;
}

export const PlanTitleBubble: FC<BubbleProps> = (props) => {
  return props.role === 'user' ? (
    <Element name={props.message.roomId}>
      <div
        className="bg-black py-2"
        style={{
          background: 'linear-gradient(74.68deg, #FF66C4 0%, #B366FF 100%)',
        }}
      >
        <div className="mb-1 flex gap-2 pl-2 pr-3">
          {!!props.sender && (
            <div className="mb-[-4px] min-w-[32px] basis-8">
              {props.sender.imageUrl && (
                <Image
                  src={props.sender.imageUrl}
                  width="32"
                  height="32"
                  className="rounded-full"
                  alt=""
                />
              )}
            </div>
          )}
          <p className="text-sm font-semibold leading-[1.4] text-white">{props.message.text}</p>
        </div>
        <div className="px-2 text-right">
          <p className="text-xs text-white">
            購入日：{dayjs(props.message.createTime).format('YYYY/MM/DD HH:mm')}
          </p>
        </div>
      </div>
    </Element>
  ) : (
    <TextBubble {...props} />
  );
};
